import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { PRIMARY_COLOR, DARK_PRIMARY_COLOR } from '../../constants';
import s from './Loader.css';
import { useSelector } from 'react-redux';

const CustomCircleLoader = (props) => {
    const theme = useSelector(state => state?.currency?.theme);

    const { size = 48, singleColor = theme === 'dark' ? DARK_PRIMARY_COLOR : PRIMARY_COLOR, borderSize = 5 } = props;
    return (
        <div className={s.customCircleLoad} style={{ width: size, height: size, borderColor: singleColor, borderWidth: borderSize }}></div>
    )
}

export default withStyles(s)(CustomCircleLoader);